import { cn } from '@/utils/cn'
import type { Deal } from '@/types'
import { getStageStepper } from './dealDetailPanelConfig'

export function DealDetailStageStepper({ deal }: { deal: Deal }) {
  const stepper = getStageStepper(deal)

  if (stepper.kind === 'terminal') {
    return (
      <p className="text-[11px] text-text-label">
        {stepper.label}
      </p>
    )
  }

  if (stepper.kind === 'unknown') return null

  const { current, total, index } = stepper

  return (
    <div className="min-w-0">
      <div className="flex items-center justify-between gap-2 text-[10px] font-medium uppercase tracking-wider text-text-label">
        <span>Pipeline</span>
        <span className="tabular-nums text-text-muted">
          Etapa {current} de {total}
        </span>
      </div>
      <div
        className="deal-detail-stepper-track mt-1.5"
        role="progressbar"
        aria-valuenow={current}
        aria-valuemin={1}
        aria-valuemax={total}
        aria-label={`Etapa ${current} de ${total} no pipeline`}
      >
        {Array.from({ length: total }, (_, i) => (
          <div
            key={i}
            className={cn(
              'deal-detail-stepper-segment',
              i < index && 'is-complete',
              i === index && 'is-current',
            )}
          />
        ))}
      </div>
    </div>
  )
}
